const blueDark = {
  25: "#F5F8FF",
  50: "#EFF4FF",
  100: "#D1E0FF",
  200: "#B2CCFF",
  300: "#84ADFF",
  400: "#528BFF",
  500: "#2970FF",
  600: "#155EEF",
  700: "#004EEB",
  800: "#0040C1",
  900: "#00359E",
  950: "#002266",
};

export default blueDark;
